export default __webpack_public_path__ + "static/media/confia-logo.583cdd55.svg";